import React, { Component } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Row,
  Col,
  Alert,
} from 'reactstrap';
import ReactTooltip from 'react-tooltip';
import { FetchData } from './utils/DataFetch';
import { GetCookie } from './utils/Common';

import { WorkOrderClaimantJobsTableDefault } from './WorkOrderClaimantJobsTableDefault';
import { LoadingModal } from './LoadingModal';

export class WorkOrderClaimantJobs extends Component {
  static displayName = WorkOrderClaimantJobs.name;
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      workOrders: [],
      model: this.props.model,
      alert: this.props.alert,
      sortModel: {
        SortBy: 'jobDateTime',
        SortDirection: 'desc',
      },
    };
    this.user = JSON.parse(GetCookie('user'));
    this.populateFollowUps = this.populateFollowUps.bind(this);
    this.handleDoubleClick = this.handleDoubleClick.bind(this);
    this.keydownHandler = this.keydownHandler.bind(this);
  }

  componentDidMount() {
    this.populateFollowUps();
    // Add event listener for keyboard events
    document.addEventListener('keydown', this.keydownHandler);
  }

  componentWillUnmount() {
    // Remove event listener when component unmounts
    document.removeEventListener('keydown', this.keydownHandler);
  }

  componentDidUpdate() {
    ReactTooltip.rebuild();
  }

  async populateFollowUps() {
    this.setState({ loading: true, fetchingData: true });
    var model = { ClmId: this.state.model.ClmId };
    await FetchData('/getworkorders', 'POST', this.user.token, model).then(
      (data) => {
        this.setState({
          workOrders: data,
          loading: false,
          fetchingData: false,
        });
      }
    );
  }

  handleDoubleClick(workOrder) {
    window.open(`${window.location.origin}/?jobid=${workOrder.jobId}`, '_blank');
  }

  keydownHandler(e) {
    // Only handle keyboard events when this modal is open
    if (this.props.modal) {
      if (e.keyCode === 27) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        this.props.setModal();
      }
    }
  }

  renderClaimantJobs(workOrders) {
    return (
      <WorkOrderClaimantJobsTableDefault
        workOrders={workOrders}
        handleDoubleClick={this.handleDoubleClick}
      />
    );
  }

  render() {
    let contents = this.state.loading ? (
      <p>
        <em>Loading...</em>
      </p>
    ) : (
      this.renderClaimantJobs(this.state.workOrders)
    );

    return (
      <div>
        <Modal
          isOpen={this.props.modal}
          toggle={this.props.setModal}
          style={{ height: '460px', width: '1280px' }}
          backdrop="static"
        >
          <ModalHeader>Claimant Jobs</ModalHeader>
          <ModalBody style={{ height: '500px' }}>
            <Row>
              <Col style={{ textAlign: 'center' }}>
                <Alert
                  color={this.state.alert.color}
                  isOpen={this.state.alert.isOpen}
                >
                  {this.state.alert.message}
                </Alert>
              </Col>
            </Row>
            <ReactTooltip
              className="tooltip"
              id="rtp"
              place="top"
              type="dark"
              effect="solid"
              html={true}
            />
            <LoadingModal fetchingData={this.state.fetchingData} />

            <Col>{contents}</Col>
          </ModalBody>
          <ModalFooter></ModalFooter>
        </Modal>

      </div>
    );
  }
}
